import data from "./data.json";

export default function searchJobs(searches) {
	const jobs = Object.entries(data);
	const searchArray = searches;
	let showJobs = [];

	let sortedJobs = jobs.map((job) => {
		return [job[1].role, job[1].level, ...job[1].languages, ...job[1].tools].filter((search) => {
			return searchArray.includes(search);
		});
	});

	for (let i = 0; i < sortedJobs.length; i++) {
		if (sortedJobs[i].length === searchArray.length) {
			showJobs.push(jobs[i]);
		}
	}

	if (searchArray.length === 0) {
		showJobs = jobs;
	}

	return showJobs;
}
